"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatAll = void 0;
/**
 *
 * @category Front End
 * @param {Array<Array>} arrays An array of arrays to concatenate into a single array
 * @returns {Array}
 */
function concatAll() {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    return arrays.reduce(function (prev, curr) {
        return prev.concat(curr);
    }, []);
}
exports.concatAll = concatAll;
//# sourceMappingURL=array.js.map